export default __webpack_public_path__ + "static/media/pantry1-afterF-1920w.a1b2091b.png";